"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aCmsElementWithDynamicStyles = exports.aCmsElementContext = exports.mockApiResponse = exports.aBannerData = exports.aDealerOffersDataResponse = exports.cmsBannerTemplateData = exports.cmsDataStoreInitData = exports.pageSettingsMock = exports.closeElementMock = exports.clickablElementsMock = exports.buttonMock = exports.imageMock = exports.elementsMock = exports.openChatElement = void 0;
var tslib_1 = require("tslib");
var enElement = {
    color: 'rgb(43, 86, 114)',
    width: 204,
    height: 37,
    top: 418,
    left: 22,
    cssClass: 'helvetica-neue-light-45',
    cssBold: '',
    cssUnderline: '',
    cssItalic: '',
    lineHeight: 18,
    rotate: 45,
    zIndex: 3,
    align: 'left',
    clickable: false,
    params: [
        { key: '{0}', string: '-REPLACE:1-' },
        { key: '{1}', string: '-REPLACE:2-' },
    ],
    topPadding: 12,
    leftPadding: 32,
    fontWeight: '400',
    fontSize: 14,
};
var frElement = {
    fontSize: 24,
};
var imgElement = function () { return ({
    top: 218,
    src: '/media/fbbdbc53-0ef6-46f6-aebb-999554e92684.png',
    hoverSrc: '/media/df7b619b-7704-4fce-8604-86a21decac36.png',
    clickable: true,
}); };
var btnElement = function () { return ({
    color: '#ffffff',
    colorOnHover: 'rgba(242, 86, 77, 1)',
    bgColor: 'rgba(242, 86, 77, 1)',
    bgColorOnHover: '#ffffff',
    borderColor: 'rgba(142, 186, 177, 1)',
    borderColorOnHover: 'rgba(242, 86, 77, 1)',
    width: 155,
    height: 42,
    top: 318,
}); };
var clickParams = function () { return ({
    top: 118,
    clickable: true,
    clickAction: 'metaSiteDependent',
    clickActionParams: {
        isOpenInNewTab: false,
        defaultUrl: 'https://www.wix.com/my-account/sites?referralAdditionalInfo=###REFFERAL-INFO###',
        metaSiteUrl: 'https://www.wix.com/my-account/sites/###METASITE###?referralAdditionalInfo=###REFFERAL-INFO###',
        abTest: 'BI MAMA',
    },
}); };
var closeParams = function () { return ({
    top: 118,
    clickable: true,
    clickAction: 'closeLightbox',
    clickActionParams: {
        isOpenInNewTab: false,
        defaultUrl: 'https://www.wix.com/my-account/sites?referralAdditionalInfo=###REFFERAL-INFO###',
        metaSiteUrl: 'https://www.wix.com/my-account/sites/###METASITE###?referralAdditionalInfo=###REFFERAL-INFO###',
        abTest: 'BI MAMA',
    },
}); };
var openChatParams = function (tenantName, widgetId) { return ({
    top: 118,
    clickable: true,
    clickAction: 'openChat',
    clickActionParams: {
        tenantName: tenantName,
        widgetId: widgetId,
    },
}); };
var basicElement = function () { return ({ en: enElement, fr: frElement }); };
var imageElement = function () { return ({ en: tslib_1.__assign({}, imgElement()) }); };
var clickElement = function () { return ({ en: tslib_1.__assign(tslib_1.__assign({}, enElement), clickParams()) }); };
var buttonElement = function () { return ({
    en: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, enElement), clickParams()), btnElement()),
}); };
var closeLightboxElement = function () { return ({
    en: tslib_1.__assign(tslib_1.__assign({}, enElement), closeParams()),
}); };
exports.openChatElement = function (tenantName, widgetId) { return ({
    en: tslib_1.__assign(tslib_1.__assign({}, enElement), openChatParams(tenantName, widgetId)),
}); };
exports.elementsMock = function (element) { return (tslib_1.__assign(tslib_1.__assign({}, basicElement()), element)); };
exports.imageMock = function (element) { return (tslib_1.__assign(tslib_1.__assign({}, imageElement()), element)); };
exports.buttonMock = function (element) { return (tslib_1.__assign(tslib_1.__assign({}, buttonElement()), element)); };
exports.clickablElementsMock = function (element) { return (tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, {}), clickElement()), element)); };
exports.closeElementMock = function () { return (tslib_1.__assign(tslib_1.__assign({}, {}), closeLightboxElement())); };
exports.pageSettingsMock = function () { return ({
    name: 'MA_Upgrade_Banner_2',
    backgroundColor: 'rgba(255, 155, 155, 0.2)',
    selected: true,
    en: {
        clickable: false,
        name: 'MA_Upgrade_Banner_2',
        bannerWidth: '246',
        bannerHeight: '520',
    },
}); };
exports.cmsDataStoreInitData = function () { return ({
    bannerPosition: 'LIST_LEFT',
    metasiteGuid: '',
    locale: 'en',
    translationsUrl: '',
}); };
exports.cmsBannerTemplateData = function () { return ({
    templateSetting: {
        cmsBanner: 'true',
        templateName: 'interactive-template',
    },
    pageSetting: exports.pageSettingsMock(),
    Zone_main: {
        items: [
            exports.elementsMock({ type: 'text', id: 1, textKey: 'keyForText' }),
            exports.clickablElementsMock({ type: 'Image', id: 2 }),
            exports.buttonMock({ type: 'cmsButton', id: 3, textKey: 'keyForText' }),
        ],
    },
}); };
exports.aDealerOffersDataResponse = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.bannerTemplate, bannerTemplate = _c === void 0 ? JSON.stringify(exports.cmsBannerTemplateData()) : _c, _d = _b.position, position = _d === void 0 ? 'LIST_LEFT' : _d, _e = _b.emptyData, emptyData = _e === void 0 ? false : _e;
    return Promise.resolve(emptyData
        ? { offers: [] }
        : {
            offers: [
                {
                    asset: {
                        payloadJson: JSON.stringify({
                            templateId: '00000000-0000-4c7b-b20f-9af7b5da1bd2',
                            template: bannerTemplate,
                        }),
                        dynamicParams: {
                            domainName: 'mysite.com',
                            siteName: 'sitename',
                            userName: 'borisTheUser',
                        },
                    },
                    realEstateId: position,
                    offerGuid: 'fd7bd959-d713-4396-9f26-c9366116e703',
                },
            ],
        });
};
exports.aBannerData = function (position, bannerTemplate) {
    if (position === void 0) { position = 'MOCK_BANNER_POSITION'; }
    if (bannerTemplate === void 0) { bannerTemplate = exports.cmsBannerTemplateData(); }
    return ({
        bannerPosition: position,
        bannerId: '00000000-0000-4c7b-b20f-9af7b5da1bd2',
        dynamicParams: {
            domainName: 'mysite.com',
            siteName: 'sitename',
            userName: 'borisTheUser',
        },
        bannerTemplate: bannerTemplate,
        isPremium: false,
        saleType: 'Seasonal',
        lightboxGuid: 'fd7bd959-d713-4396-9f26-c9366116e703',
        daysLeft: 10,
    });
};
exports.mockApiResponse = function (params) {
    var returnedData = {
        dealerData: {},
    };
    params.bannerPositions.forEach(function (bannerPosition) {
        return (returnedData.dealerData[bannerPosition] = [{ bannerTemplate: '' }]);
    });
    return returnedData;
};
exports.aCmsElementContext = function (override) {
    return tslib_1.__assign({ daysLeft: 0, dynamicParams: {}, locale: 'en', saleType: null, experiments: {} }, override);
};
exports.aCmsElementWithDynamicStyles = function (styles, langExtension) { return (tslib_1.__assign(tslib_1.__assign({ id: 0, type: 'text', textKey: 'lb_seo_new_title' }, styles), langExtension)); };
//# sourceMappingURL=elementMock.js.map